"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const blogArticleInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    helperText: "The title of the blog post",
  },
  {
    name: "subtitle",
    type: "string",
    required: true,
    helperText: "The topic/category of the blog post",
  },
  {
    name: "readTime",
    type: "string",
    required: true,
    helperText: "Read time",
  },
  {
    name: "image",
    type: "object",
    subFields: [
      {
        name: "smallReference",
        type: "file",
        required: true,
        helperText: "Small version of the image",
        defaultValue: "",
      },
      {
        name: "mediumReference",
        type: "file",
        required: true,
        helperText: "Medium version of the image",
        defaultValue: "",
      },
      {
        name: "largeReference",
        type: "file",
        required: true,
        helperText: "Large version of the image",
      },
      {
        name: "altText",
        type: "string",
        required: true,
        helperText: "Alternative text for the image",
      },
    ],
  },
  {
    name: "creationDate",
    type: "date",
    required: true,
    helperText: "The creation date of the blog post",
  },
  {
    name: "showAuthor",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "author",
    type: "string",
    showIf: `options.get("showAuthor")`,
  },
  {
    name: "blogTags",
    type: "list",
    subFields: [
      {
        name: "tag",
        type: "string",
        helperText: "Blog tag",
      },
    ],
  },
  {
    name: "relatedArticlesTitle",
    type: "string",
    helperText: "The title of the blog related Articles",
    defaultValue: "Related Articles",
  },
  {
    name: "relatedArticlesCtaLabel",
    type: "string",
    helperText: "The label of the cta",
    defaultValue: "View all products",
  },
  {
    name: "relatedArticlesCtaUrl",
    type: "string",
    helperText: "The url of the cta",
    defaultValue: "/products",
  },
  {
    name: "relatedArticles",
    type: "list",
    subFields: [
      {
        name: "article",
        type: "reference",
        model: "blog-single-article-section-model",
      },
    ],
  },
] as const satisfies Inputs;

export const BlogArticleComponent: RegisteredComponent = {
  name: "Blog Article",
  component: dynamic(async () =>
    withValidation(
      blogArticleInputs,
      (await import("./BlogArticle")).BlogArticle,
      "BlogArticle"
    )
  ),
  canHaveChildren: true,
  childRequirements: {
    message:
      "You can only put Text, Image and VideoPlayer components inside this component",
    query: {
      "component.name": {
        $in: ["Text", "Image", "VideoPlayer"],
      },
    },
  },
  inputs: blogArticleInputs,
};
